import apiClient from '@/services/rest-api-sms/apiClient'

const baseEndpoint = '/image-validation'

export const validateImage = async (file) => {
  const formData = new FormData()
  formData.append('file', file)

  const response = await apiClient({
    method: 'POST',
    url: baseEndpoint,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data: formData,
  })

  return response?.data
}
